import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import {
  View,
  StyleSheet,
  ViewStyle,
} from "react-native";

import Confetti from "../../components/Confetti";

export interface PremiumBackgroundProps {
  children?: React.ReactNode;
  style?: ViewStyle;
  confetti?: boolean;
}

const PremiumBackground: React.FC<PremiumBackgroundProps> = ({
  children,
  style,
  confetti = false,
}) => {
  return (
    <LinearGradient
      colors={[
        '#667eea', // Soft purple-blue (0%)
        '#764ba2', // Deep purple (25%)
        '#f093fb', // Light pink (75%)
        '#f5576c', // Coral pink (100%)
      ]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={[styles.background, style]}
    >
      {confetti && <Confetti trigger={confetti} />}
      <View style={styles.content}>{children ?? null}</View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  background: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
  content: {
    flex: 1,
    width: "100%",
    height: "100%",
    paddingTop: 24,
    paddingHorizontal: 16,
  },
});

export default PremiumBackground;
